import React, { Component } from "react";
// import logobianco from "../../../assets/img/logo_white.svg";
import classes from "./Login.module.scss";
// import Background from "../../../assets/img/signupBG.png";
import axios from "../../../Utils/AxiosCaller";
import { Redirect, Link } from "react-router-dom";
import { setUser } from "../../../store/actions";
import { connect } from "react-redux";
import jcf from "jcf/dist/js/jcf";
import redirectUri from "../../../Utils/RedirectUrlGenerator.js";
import Button from "noku-library/dist/Input/Button/Button";
import Input from "../../UI/Input/BaseInput/Input";
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import SplashLogo from "@noku-tech/nokulibrary-frontend/dist/Output/SplashLogo/SplashLogo";
import getUrlByClientId from "@noku-tech/nokulibrary-common/dist/functions/utils/getUrlByClientId";
import Loading from "../../Loading/Loading";

const mapDispatchToProps = dispatch => {
  return {
    updateCurrentUser: user => dispatch(setUser(user))
  };
};

const useLogoBlack = process.env.REACT_APP_USE_LOGO_BLACK === "true";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loginError: null,
      loginErrorDescription: "",
      // email: "",
      // password: "",
      loginSuccess: false,
      loaded: false,
      twoFactor: false,
      loading: false,
      loginEidooFailed: false
    };

    this._isMounted = false;
    this.twoFactorCode = React.createRef();
    this.email = React.createRef();
    this.password = React.createRef();
    this.btnLogin = React.createRef();

    this.showAlert = this.showAlert.bind(this);
    this.handleEmailInput = this.handleEmailInput.bind(this);
    this.handlePasswordInput = this.handlePasswordInput.bind(this);
    this.checkLoggedIn = this.checkLoggedIn.bind(this);
    this.cancelTwoFactor = this.cancelTwoFactor.bind(this);
    this.loginFunction = this.loginFunction.bind(this);
    this.handleFormLogin = this.handleFormLogin.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
    this.checkLoggedIn();
  }

  checkLoggedIn() {
    axios
      .get("/api/amiauth")
      .then(res => {
        if (res.data.isAuth) {
          this._isMounted &&
            this.setState(() => {
              return {
                loaded: true,
                loginSuccess: true,
                loginEidooFailed: false
              };
            });
          jcf.setOptions("Select", {
            wrapNative: false,
            wrapNativeOnMobile: true,
            maxVisibleItems: 6
          });
          jcf.replaceAll();
        } else {


          if (process.env.REACT_APP_IS_NOKU === "true") {
            this._isMounted &&
              this.setState(() => {
                return {
                  loaded: true
                };
              });
            jcf.setOptions("Select", {
              wrapNative: false,
              wrapNativeOnMobile: true,
              maxVisibleItems: 6
            });
            jcf.replaceAll();
          } else {
            //eidoo pro

            return this._isMounted &&
              this.setState(() => {
                return {
                  loginEidooFailed: true
                };
              });
          }

        }
      })
      .catch(err => {
        this._isMounted &&
          this.setState(() => {
            return {
              loaded: true
            };
          });
        jcf.setOptions("Select", {
          wrapNative: false,
          wrapNativeOnMobile: true,
          maxVisibleItems: 6
        });
        jcf.replaceAll();
      });
  }

  UNSAFE_componentWillMount() {
    this._isMounted = false;
  }

  showAlert() {
    if (this.props.location && this.props.location.state && this.props.location.state.messageForgot) {
      return (
        <div className="alert alert-success">
          {this.props.location.state.messageForgot}
        </div>
      );
    }
    if (null != this.state.loginError) {
      if (this.state.loginError) {
        return (
          <div className="alert alert-danger">
            {this.state.loginErrorDescription}
          </div>
        );
      } else {
        return (
          <div className="alert alert-success">
            {this.state.loginErrorDescription}
          </div>
        );
      }
    }
  }

  handleEmailInput(e) {
    const emailValue = e.target.value;
    if (emailValue !== "") {
      if (this._isMounted) {
        this.setState(() => {
          return {
            email: emailValue
          };
        });
      }
    }
  }

  handlePasswordInput(e) {
    const passwordValue = e.target.value;
    if (passwordValue !== "") {
      if (this._isMounted) {
        this.setState(() => {
          return {
            password: passwordValue
          };
        });
      }
    }
  }

  handleFormLogin = (e) => {
    e.preventDefault();
    try {
      this.loginFunction(this);
    } catch (err) { }
    //todo block form until form has finished
  }

  focusTwoFactorCode() {
    setTimeout((_this) => {
      if (_this.twoFactorCode) {
        _this.twoFactorCode.current.focus();
      }
    }, 410, this);
  }

  async loginFunction(_this) {
    _this._isMounted && _this.setState({
      loading: true,
      loginError: null,
    });

    const parameter = {
      email: _this.email.current.value,
      password: _this.password.current.value,
      code2fa: _this.twoFactorCode.current ? _this.twoFactorCode.current.value : undefined
    };

    const url = redirectUri("/login");

    try {
      let responseAxios = await axios.post(url, parameter);
      let response = responseAxios.response;

      let data = (response || {}).data || {};
      if (data.error) {
        throw new Error(data.description);
      }

      data = responseAxios.data;

      if (data.twoFactorRequired) {
        _this.btnLogin.current.focus();
        setTimeout(() => {
          _this._isMounted && _this.setState({
            twoFactor: true,
            loading: false,
            loginError: null
          }, () => {
            _this.focusTwoFactorCode();
          });
        }, 500);

      } else {
        if (data && !data.isEmailVerified) {
          _this.props.updateCurrentUser({ isNewUser: true, id: data.id });
          this.props.history.push(redirectUri(`/validate-code`));
        } else if (data && data.redirectURI) {
          const redirectURL = data.redirectURI;
          window.location.href = redirectURL;
        } else {
          _this.props.updateCurrentUser(data.user);
          if (_this._isMounted) {
            _this.setState(() => {
              return {
                loginError: null,
                loading: false,
                loginSuccess: true
              };
            });
          }
        }
      }
    } catch (error) {
      let errorMessage = null;
      if (
        null != error.response &&
        null != error.response.data &&
        null !== error.response.data.description &&
        null != error.response.data.description
      ) {
        errorMessage = error.response.data.description.message;
      } else {
        errorMessage = error.message || "Generic Error";
      }
      if (_this._isMounted) {
        _this.setState(() => {
          return {
            loading: false,
            loginError: true,
            loginErrorDescription: errorMessage
          };
        });
      }
      return "";
    }

  }

  cancelTwoFactor() {
    this._isMounted && this.setState({
      twoFactor: false
    });
  }

  renderForm = () => {
    return process.env.REACT_APP_IS_NOKU === "true" ?
      <div className={classes.formContainer}>
        <Input
          className={classes.inputContainer}
          autoComplete="email"
          elementType="input"
          inputType="email"
          refer={this.email}
          // onChange={this.handleEmailInput}
          label="Email"
        />
        <Input
          className={classes.inputContainer}
          autoComplete="current-password"
          elementType="input"
          inputType="password"
          refer={this.password}
          // onChange={this.handlePasswordInput}
          label="Password"
        />
      </div>
      : null;
  }

  render() {
    const { t, customizationVariables } = this.props;
    const alert = this.showAlert();

    if (this.state.loginSuccess) {
			const params = new URLSearchParams(window.location.search);
			let redirectUri = params.get('redirect_uri');

			if (redirectUri) {
				try {
					const clientId = params.get('client_id');
					const clientUrl = getUrlByClientId(clientId);
					return window.location.href = `${clientUrl}${redirectUri?.startsWith?.("/") ? "" : "/"}${redirectUri}`;
				} catch (e) {}
			}

      return <Redirect to="/home" />;
    }

    if (this.state.loginEidooFailed) {
      return <Redirect to={process.env.REACT_APP_IS_NOKU === "true" ? "/" : "/start"} />;
    }

    let twoFactorLogin = this.state.twoFactor ?
      <>
        <div className="two-factor">
          <div className="back link-special" onClick={this.cancelTwoFactor}>
            <i className="fas fa-arrow-left"></i> Back
          </div>
          <div className="container-two-factor">
            <div className="text"></div>
            <div className="form-group form-item login-form-element">
              <label htmlFor="code2fa">Two Factor Authentication</label>
              <div className="passwordicon">
                <input
                  type="text"
                  className="form-control obbl"
                  placeholder="Code"
                  ref={this.twoFactorCode}
                />
              </div>
            </div>
          </div>
        </div>
      </>
      :
      null;

    return (
      <>
        {this.state.loaded ? (
          <div className={`login ${classes.loginPage}`}>
            <div className={`flex-container stretch`}>
              <div className={`block flex-container ${classes.leftPanel}`}>
                <SplashLogo className={classes.splashLogo} useLogoBlack={useLogoBlack} />
                <div className={`${customizationVariables.hasCustomBackground ? classes.backgroundImage : "mask only-mobile"}`} />
                <div className={classes.loginCard}>
                  <div className="">
                    <div className={`title ${classes.loginTitle}`}>
                      {t('loginText')}
                    </div>
                    <form onSubmit={this.handleFormLogin} method="POST" className={`validateSubmit form-login-container ${this.state.loading ? "loading" : ""} ${this.state.twoFactor ? 'two-factor-enabled' : ''}`}>
                      {alert}

                      <div className={`container-loading ${classes.loginHolder}`}>
                        <div className={`container-login`}>

                          {this.state.twoFactor ? <div>{twoFactorLogin}</div> : null}
                          <div style={{ display: this.state.twoFactor ? 'none' : 'block', width: '100%' }}>
                            {this.renderForm()}
                          </div>

                        </div>
                        <Button loading={this.state.loading} buttonClassName={classes.loginButton} type="submit" ref={this.btnLogin}>
                          {t('login')}
                        </Button>
                        <span className="forgotpassword">
                          <Link className={`${classes.link} link-special`} to={redirectUri("/forgot")}>
                            {t('forgotPassword')}
                          </Link>
                        </span>
                      </div>
                    </form>
                  </div>
                  <div className={classes.footer}>
                    <span className={classes.label}>{t("notYetSignedUp")}</span>

                    <Button buttonClassName={classes.createAccountBtn} link={redirectUri("/signup")}>
                      {t('createYourAccount')}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <Loading />
        )}
      </>
    );
  }
}

// const infoBoxStyle = {
//   backgroundImage: `url(${Background})`
// };

const mapStateToProps = ({ base }) => {
  return {
    customizationVariables: base.customizationVariables
  };
};

export default compose(
  withTranslation("noku-account"),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ))(Login);
